import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export { default as extend } from './extend';
app.initializers.add('hli-approval-notify', () => {
  // Shown to every user: the grid has no per-user visibility hook, and
  // the row is harmless for users who can never approve (they never
  // receive this notification).
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    items.add('postAwaitingApproval', {
      name: 'postAwaitingApproval',
      icon: 'fas fa-user-check',
      label: app.translator.trans('hli-approval-notify.forum.settings.notify_post_awaiting_approval_label')
    });
  });
});